import React from "react";
import { homebanner2 } from "../../../Constant/Index";
import ReUse from "../../../services/helpers/reUse";
import CustomImage from "../../../Components/ReUse/Components/Image";

const RightFirst = ({ allBanners }) => {
	const isArrayHasIndex = ReUse.isArrayHasIndex({
		arrayInput: allBanners,
		index: 1,
	});

	const banner = isArrayHasIndex ? allBanners[1] : {};

	const {
		id,
		photo,
		banner_type,
		published,
		url,
		resource_type,
		title,
		sub_title,
		description,
	} = banner ?? {};

	return (
		isArrayHasIndex && (
			<div className="banner-first-img second-banner-img">
				<figure>
					<CustomImage thumbnail={photo} />
				</figure>
				<div className="second-banner-text">
					<div className="second-all-text wow animate__animated animate__fadeInRightBig">
						<h4>{title}</h4>
						<h4>{sub_title}</h4>
					</div>
				</div>
			</div>
		)
	);
};

export default RightFirst;
